import { RoleType } from "@/types/api";
import { PinnedItem } from "@/types/pinnedItems";

/**
 * Check if user can create pins with ENTERPRISE scope
 * Only ENTERPRISE_ADMIN and SUPER_ADMIN can create enterprise-wide pins
 */
export const canCreateEnterprisePin = (roleType: RoleType | null): boolean => {
  return roleType === "ENTERPRISE_ADMIN" || roleType === "SUPER_ADMIN";
};

/**
 * Check if user can delete a pinned item based on scope and ownership
 * - PERSONAL pins: only the owner can delete
 * - ENTERPRISE pins: only admins can delete
 */
export const canDeletePinnedItem = (
  item: PinnedItem,
  userId: number | undefined,
  roleType: RoleType | null
): boolean => {
  if (!userId) return false;

  if (item.scope === "PERSONAL") {
    // Personal pins: only owner can delete
    return item.pinnedByUserId === userId;
  }

  // Enterprise pins: only admins can delete
  return roleType === "ENTERPRISE_ADMIN" || roleType === "SUPER_ADMIN";
};

/**
 * Check if user can edit a pinned item
 * Same permissions as delete
 */
export const canEditPinnedItem = (
  item: PinnedItem,
  userId: number | undefined,
  roleType: RoleType | null
): boolean => {
  return canDeletePinnedItem(item, userId, roleType);
};

/**
 * Check if user can change the scope of a pinned item
 * Only admins can change scope (to avoid confusion for non-admins
 * who cannot promote to ENTERPRISE scope anyway)
 */
export const canEditPinnedItemScope = (roleType: RoleType | null): boolean => {
  return roleType === "ENTERPRISE_ADMIN" || roleType === "SUPER_ADMIN";
};
